import { assign } from 'fsm';
import { fetchCurrentUsage } from './client';
export const machine = {
  initial: 'initializing',
  states: {
    initializing: {
      always: [{
        cond: 'canViewCredits',
        target: 'loadingCredits'
      }, {
        target: 'idle',
        actions: ['setEmptyCredits']
      }]
    },
    loadingCredits: {
      invoke: {
        src: 'fetchCurrentUsage',
        onDone: [{
          target: 'idle',
          actions: ['setCredits']
        }],
        onError: [{
          cond: 'hasNoUsagePlan',
          target: 'idle',
          actions: ['setEmptyCredits']
        }, {
          target: 'error'
        }]
      },
      tags: ['loading']
    },
    idle: {
      on: {
        REFRESH: 'loadingCredits'
      }
    },
    error: {
      on: {
        REFRESH: 'loadingCredits'
      },
      tags: ['error']
    }
  },
  actions: {
    setCredits: assign((_context, event) => {
      const {
        data
      } = event || {};
      return {
        data
      };
    }),
    setEmptyCredits: assign(() => {
      return {
        data: undefined
      };
    }),
    setErrorId: assign((_context, event) => {
      const {
        responseJSON
      } = event.data;
      const {
        correlationId
      } = responseJSON;
      return {
        errorId: correlationId
      };
    })
  },
  guards: {
    canViewCredits: context => {
      return context.currentUser.hasCreditsPlan();
    },
    hasNoUsagePlan: (_context, event) => {
      const {
        message
      } = event.data;
      if (message === 'This portal has no usage plan') {
        return true;
      }
      return false;
    }
  },
  services: {
    fetchCurrentUsage
  }
};